import config from "@/lib/config";
import connectRedis from "@/lib/connectRedis";
import { createCipheriv, createDecipheriv, randomBytes } from "crypto";
import jwt from "jsonwebtoken";
export default class PasswordToken {
  constructor(req, res) {
    var _config$passwordToken, _config$passwordToken2, _config$passwordToken3, _config$passwordToken4;
    this.req = req;
    this.res = res;
    this.redis = connectRedis({
      host: process.env.REDIS_HOST || ((_config$passwordToken = config.passwordToken.redis) === null || _config$passwordToken === void 0 ? void 0 : _config$passwordToken.host),
      port: process.env.REDIS_PORT || ((_config$passwordToken2 = config.passwordToken.redis) === null || _config$passwordToken2 === void 0 ? void 0 : _config$passwordToken2.port),
      keyPrefix: config.passwordToken.redis.prefix,
      db: (_config$passwordToken3 = config.passwordToken.redis) === null || _config$passwordToken3 === void 0 ? void 0 : _config$passwordToken3.db
    }, (_config$passwordToken4 = config.passwordToken) === null || _config$passwordToken4 === void 0 || (_config$passwordToken4 = _config$passwordToken4.redis) === null || _config$passwordToken4 === void 0 ? void 0 : _config$passwordToken4.cluster);
  }
  generateToken() {
    return randomBytes(16).toString("hex");
  }
  generateEncryptionKey() {
    return randomBytes(32);
  }
  encrypt(text, encryptionKey) {
    const iv = randomBytes(config.passwordToken.ivLength);
    const cipher = createCipheriv(config.passwordToken.algorithm, Buffer.from(encryptionKey, "hex"), iv);
    let encrypted = cipher.update(text);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    return iv.toString("hex") + ":" + encrypted.toString("hex");
  }
  decrypt(text, encryptionKey) {
    const textParts = text.split(":");
    const iv = Buffer.from(textParts.shift(), "hex");
    const encryptedText = Buffer.from(textParts.join(":"), "hex");
    const decipher = createDecipheriv(config.passwordToken.algorithm, Buffer.from(encryptionKey, "hex"), iv);
    let decrypted = decipher.update(encryptedText);
    decrypted = Buffer.concat([decrypted, decipher.final()]);
    return decrypted.toString();
  }
  async getValue(jwtToken) {
    // return mailAddress
    try {
      // key : jwtToken
      const verifiedToken = jwt.verify(jwtToken, config.passwordToken.jwtSecret);
      const token = verifiedToken.token;
      const encryptionKey = verifiedToken.encryptionKey;
      const encryptedText = await this.redis.get(token);
      const decryptedText = this.decrypt(encryptedText, encryptionKey);
      return decryptedText;
    } catch (e) {
      console.log("password token get value error", e);
    }
  }
  async publish(key) {
    // key : mailAddress
    const token = this.generateToken();
    const encryptionKey = this.generateEncryptionKey();
    const encryptedText = this.encrypt(key, encryptionKey);
    await this.redis.multi().set(token, encryptedText).expire(token, config.passwordToken.maxAge).exec();
    const jwtToken = jwt.sign({
      token,
      encryptionKey
    }, config.passwordToken.jwtSecret);
    return jwtToken;
  }
  async verify(jwtToken) {
    const res = await this.getValue(jwtToken);
    return (res === null || res === void 0 ? void 0 : res.length) > 0;
  }
  async delete(jwtToken) {
    try {
      const verifiedToken = jwt.verify(jwtToken, config.passwordToken.jwtSecret);
      const token = verifiedToken.token;
      await this.redis.del(token);
    } catch (e) {
      console.log("password token delete error", e);
    }
  }
}